import React from 'react';
import { Stack, Typography, Button } from '@mui/material';
import { DownloadProcessSteps } from "./DataDownloadProcess"
import StepperDUC from "../duc/StepperDUC"
import { stepLabels } from "./DataDownloadProcess"
import { colours } from '../../StyleConstants';
import Selector from './components/Selector';

const dummyData = {
    'ABCD': [
        { title: "Release 5.1", info: "Information about the release", latest: true },
        { title: "Release 5.0", info: "Information about the release", latest: false },
        { title: "Release 4.0", info: "Information about the release", latest: false },
        { title: "Release 3.0", info: "Information about the release", latest: false }
    ],
    'HBCD': [
        { title: "Release 1.0", info: "Information about the release", latest: true }
    ]
}

const ReleaseSelection = (props: any) => {

    const handleClickRelease = (releaseTitle: string) => {
        props.setInfo({ ...props.info, release: releaseTitle })
        props.setCurStep(DownloadProcessSteps.DatasetSelection);
    };

    const handleClickBack = () => {
        props.setCurStep(DownloadProcessSteps.StudySelection)
    }

    const selected = dummyData[props.info.study as keyof typeof dummyData];

    return (
        <Stack gap={3} sx={{ padding: 3 }}>
            <Stack flexDirection="column" gap={4} alignItems="center">
                <Typography
                    variant="h3"
                    fontWeight="600"
                    fontSize="40px"
                    textAlign="center"
                    color={colours.midnightBlue.blue}>
                    New Dataset Download
                </Typography>
                <StepperDUC
                    activeStep={DownloadProcessSteps.ReleaseSelection}
                    stepLabels={stepLabels}
                />
            </Stack>

            <Stack direction="row" justifyContent="space-between" marginTop={3}>
                <Button
                    variant="tertiary"
                    onClick={() => handleClickBack()}
                >
                    Back
                </Button>
                {/*<Button*/}
                {/*    variant="secondary"*/}
                {/*>*/}
                {/*    Go to current dataset*/}
                {/*</Button>*/}
            </Stack>

            <Stack direction="row" gap={3} sx={{ marginTop: 3 }}>
                <Stack flex={1}>
                    <Typography variant="h6" fontWeight="600" color= {colours.orange.orange}>
                        Selected study
                    </Typography>

                    <Selector
                        title={props.info.study}
                        hover={false}
                        text="Information about the study"/>

                </Stack>

                <Stack flex={2}>
                    <Typography variant="h5" fontWeight="600" color= {colours.midnightBlue.blue}>
                        Select release
                    </Typography>

                    <Stack gap={2} sx={{ width: '100%' }}>
                        {selected.map((release: any) => (
                            <Selector
                                key={release.title}
                                title={release.title}
                                hover={true}
                                handleClick={handleClickRelease}
                                clickInfo={release.title}
                                text="Information about the study"
                            />
                        ))}
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default ReleaseSelection;